/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NextPortBlacklist
 */
export interface NextPortBlacklist {
    /**
     * 
     * @type {number}
     * @memberof NextPortBlacklist
     */
    imo?: number;
    /**
     * ID for the current trip for the given vessel. This will change at every port call
     * @type {number}
     * @memberof NextPortBlacklist
     */
    trip?: number;
    /**
     * UUID of the cluster
     * @type {string}
     * @memberof NextPortBlacklist
     */
    cluster?: string;
}

/**
 * Check if a given object implements the NextPortBlacklist interface.
 */
export function instanceOfNextPortBlacklist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NextPortBlacklistFromJSON(json: any): NextPortBlacklist {
    return NextPortBlacklistFromJSONTyped(json, false);
}

export function NextPortBlacklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextPortBlacklist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'trip': !exists(json, 'trip') ? undefined : json['trip'],
        'cluster': !exists(json, 'cluster') ? undefined : json['cluster'],
    };
}

export function NextPortBlacklistToJSON(value?: NextPortBlacklist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imo': value.imo,
        'trip': value.trip,
        'cluster': value.cluster,
    };
}

